import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Courses } from './components/Courses';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { DatenschutzAGB } from './pages/DatenschutzAGB';
import { Impressum } from './pages/Impressum';
import { AdminLogin } from './pages/AdminLogin';
import { AdminPanel } from './pages/AdminPanel';
import { CookieBanner } from './components/CookieBanner';

const HomePage = () => {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Courses />
      <Footer />
      <Toaster />
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/datenschutz-agb" element={<DatenschutzAGB />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
